import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M13.5 5.94527V12.5C13.5 13.0523 13.0523 13.5 12.5 13.5H6.2H3.5C2.94772 13.5 2.5 13.0523 2.5 12.5V5.94527C2.5 5.61737 2.66075 5.3103 2.93022 5.12347L7.43022 2.00347C7.77292 1.76587 8.22708 1.76587 8.56978 2.00347L13.0698 5.12347C13.3392 5.3103 13.5 5.61737 13.5 5.94527Z"
            stroke="currentColor"
        />
        <path
            d="M6 13.5V9.5C6 8.94772 6.44772 8.5 7 8.5H9C9.55228 8.5 10 8.94772 10 9.5V13.5"
            stroke="currentColor"
        />
    </svg>
);

export default Icon;
